import React from "react";
import "../styles/product.css";


//for the for you page 
function ProductItem({ id, title, price, rating, image, description, seller, isForYou, onClick }) {
  return (
    <div className="product-card" onClick={onClick}>
      <img
        src={image}
        alt={title}
        className={isForYou ? "foryou-card__image" : "product-card__image"} // 🔹 Use larger image if For You
      />
      <div className="product-card__details">
        <h3 className="product-card__title">{title}</h3>
        <div className="product-card__info">
          <div className="product-card__price-rating">
            <p className="product-card__price">AED {price}</p>
            <p className="product-card__rating">
              <span className="rating-stars">{"⭐".repeat(Math.min(5, Math.round(rating)))}</span>
              <span className="rating-number">({rating})</span>
            </p>
          </div>
          {seller && (
            <p className="product-card__seller">
              <span className="seller-label">Seller:</span> {seller}
            </p>
          )}
          {isForYou && description && (
            <p className="product-card__description">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductItem;
